import {inject, Injectable} from '@angular/core';
import {BaseApiService} from "../base-api-service/base-api.service";
import {TokenService} from "../../auth/token-service/token.service";
import {Facility} from "../../models/facility";
import {UserService} from "../../auth/user-service/user.service";

const RESOURCE = "/system-events";

/**
 * Communicates with the Micronaut API using REST.
 * Interacts with the audit logs resource, which is refered to as `SystemEvent` in the API.
 * `AuditLog` name was chosen to match the requirements specification naming.
 */
@Injectable({
  providedIn: 'root'
})
export class AuditLogsService extends BaseApiService {
  tokenService = inject(TokenService);
  private userService = inject(UserService);

  /**
   *
   * @param reportType
   */
  logFormCancelled(reportType: string): void {
    this.logger.debug(`AuditLogsService: logFormCancelled(${reportType}) called.`);
    const path = `/report-cancelled`;

    let facility: Facility = this.userService.activeFacility()!;

    // If we're in the process of logging out, the user details will have been reset
    if (facility === null) {
      facility = this.userService.previousFacility()!;
    }

    // Use fetch to keep alive if browser closes
    fetch(this.apiUrl + RESOURCE + path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.tokenService.getToken()}`
      },
      body: JSON.stringify({reportType: reportType, facility: facility}),
      keepalive: true
    });
  }

  logLogout(): void {
    this.logger.debug(`AuditLogsService: logLogout() called.`);
    const path = `/logout`;
    // Use fetch to keep alive if browser closes
    fetch(this.apiUrl + RESOURCE + path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.tokenService.getToken()}`
      },
      keepalive: true
    });
  }
}
